import React, { memo } from 'react'
import './TabSpacer.scss'

export const TabSpacer = memo(function TabSpacer () {
  return <div className="tab-spacer" />
})
